import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Products } from 'src/app/interfaces/products.interface';

@Component({
    selector: 'app-transfer-review-section',
    templateUrl: './transfer-review-section.component.html',
    styleUrls: ['./transfer-review-section.component.scss'],
    standalone: false
})
export class TransferReviewSectionComponent implements OnInit {
  @Output() viewToggler: EventEmitter<any> = new EventEmitter();
  @Output() submitTransfer: EventEmitter<any> = new EventEmitter();
  @Output() submitSupportTransfer: EventEmitter<any> = new EventEmitter();
  @Output() navigateToInventory = new EventEmitter<void>();
  @Output() navigateToHistory = new EventEmitter<void>();
  @Output() navigateToTransfer = new EventEmitter<void>();
  @Input() form: UntypedFormGroup;
  @Input() transferMessage: string = '';
  @Input() recipientName: string = '';
  @Input() accountNumber: string = '';
  @Input() productId: string = '';
  @Input() siteIdDisplay = '';
  @Input() products: Products[] = [];

  productName: string = '';
  @Output() transferMessageChange = new EventEmitter<string>();
  loading = false;

  constructor(fb: UntypedFormBuilder) {
    this.form = fb.group({});
  }

  ngOnInit(): void {
    this.productName =
      this.products[
        this.products.findIndex((id: Products) => id.id === this.productId)
      ].name;
  }
  /* istanbul ignore next */
  tryAgainHandler() {
    this.transferMessageChange.emit('');
    this.submitTransfer.emit();
  }
  /* istanbul ignore next */
  closeTransferPopup(): void {
    this.transferMessageChange.emit('');
  }
  /* istanbul ignore next */
  handleNavigateToInventory() {
    this.navigateToInventory.emit();
  }
  /* istanbul ignore next */
  handleNavigateToHistory() {
    this.navigateToHistory.emit();
  }
  /* istanbul ignore next */
  handleNavigateToTransfer() {
    this.navigateToTransfer.emit();
  }
}
